import { render, staticRenderFns } from "./param-fiche-medical.html?vue&type=template&id=3a6bc5c0&scoped=true&external"
import script from "./param-fiche-medical.js?vue&type=script&lang=js&external"
export * from "./param-fiche-medical.js?vue&type=script&lang=js&external"
import style0 from "./param-fiche-medical.scss?vue&type=style&index=0&id=3a6bc5c0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bc5c0",
  null
  
)

export default component.exports